import { createActions, handleActions, combineActions } from "redux-actions";

const defaultState = {
  loading: false,
};

export const {
  agentBegin,
  setRoomDetails,
  setStartCall,
  setHangup,
  agentError,
} = createActions(
  "AGENT_BEGIN",
  "SET_ROOM_DETAILS",
  "SET_START_CALL",
  "SET_HANGUP",
  "AGENT_ERROR",
);

export default handleActions(
  {
    [agentBegin]: (state, { data = {} }) => {
      return { ...defaultState, loading: true };
    },
    [setRoomDetails]: (state, { payload = {} }) => {
      console.log(payload);
      return {
        ...state, ...payload, loading: false
      };
    },
    [setStartCall]: (state, { payload = {} }) => {
      console.log(payload);
      return {
        ...state, startCall: true, loading: false
      };
    },
    [setHangup]: (state, { payload = {} }) => {
      console.log(payload);
      return {
        ...state, hangupCall: true, loading: false
      };
    },
    [agentError]: (state, { payload = {} }) => {
      // console.log(payload);
      return { ...state, agentError: payload };
    },
  },
  defaultState
);
